import { Box } from "@mui/material"
import { visuallyHidden } from "@mui/utils"
import { RegimeItemDescription } from "./regime-management-slot-definitions"

// Hidden from view; the row or card points at it with aria-describedby (see regimeDescriptionId).
export function RegimeItemDescriptionText({ item }) {
    return (
        <Box component="span" id={regimeDescriptionId(item)} sx={visuallyHidden}>
            <RegimeItemDescription.Slot />
        </Box>
    )
}

export function regimeDescriptionId(item) {
    return `regime-description-${item.id}`
}
